import { useEffect, useState } from 'react';

/**
 * Tarjeta de un anuncio Meta con mini-previsualización en vivo del creativo
 * (embed de Meta, escalado), para que se vea en el reporte. Usa el mismo
 * fetchPreview(creativeId) que el modal — token de la marca, no persiste.
 * `children` = las métricas de la placa, debajo de la vista previa.
 */
export default function AdPreviewCard({ ad, fetchPreview, children }) {
  const [html, setHtml] = useState(null);
  const [status, setStatus] = useState(ad.creative_id && fetchPreview ? 'loading' : 'none');

  useEffect(() => {
    if (!ad.creative_id || !fetchPreview) {
      setStatus('none');
      return undefined;
    }
    let alive = true;
    setStatus('loading');
    Promise.resolve(fetchPreview(ad.creative_id))
      .then((d) => {
        if (!alive) return;
        const preview =
          d && typeof d === 'object' && 'preview_html' in d ? d.preview_html : typeof d === 'string' ? d : null;
        setHtml(preview);
        setStatus(preview ? 'ready' : 'error');
      })
      .catch(() => alive && setStatus('error'));
    return () => {
      alive = false;
    };
  }, [ad.creative_id, fetchPreview]);

  return (
    <div className="lp-adcard">
      <div className="lp-adprev">
        {status === 'loading' && <span className="lp-adprev-msg">Cargando vista previa…</span>}
        {(status === 'error' || status === 'none') && <span className="lp-adprev-msg">Sin vista previa</span>}
        {status === 'ready' && (
          <div className="lp-adprev-embed" dangerouslySetInnerHTML={{ __html: html }} />
        )}
      </div>
      {children}
    </div>
  );
}
